<div class="just-flex mb16 mt32" style="color: #226092;">
  <i style="font-size: 24px; margin-top: 5px;" class="pi pi-{{inputIcon}}"></i>
  <div style="font-weight: bold; font-size: 22px; margin-left: 8px;">
    {{ inputTitle | translate}}
  </div>
</div>
